// import React from "react";
// import "./App.css";
import { Outlet } from "react-router-dom";
// import Container from "@mui/material/Container";
import Header from "./fragments/header/Header";
import Footer from "./fragments/footer/Footer";
import { useEffect } from "react";
// import { domain } from "./constants/generalConstant";

function App() {
  useEffect(() => {
    document.title = "Shippers Route Limited";
  }, []);

  return (
    <main className="   overflow-hidden  ">
      <Header />
      {/* <Container sx={{ minHeight: "100vh", width: "100vw" }}> */}
      <Outlet />
      {/* </Container> */}
      <Footer />
    </main>
  );
}

export default App;
